export const ICON = 'ICON';